// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2AxxX","image":"Header_image__2sgqS","name":"Header_name__1fVhh","info":"Header_info__yZWlc","infoRow":"Header_infoRow__2hXUm"};